import {useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";

import useDialog from "../../hooks/useDialog";


const useQuoteUX = () => {
    const params = useParams();
    const navigate = useNavigate();

    const selectedQuoteId = params.quoteId || null;

    const formQuote = useDialog("new");
    const quoteDialog = useDialog(`${selectedQuoteId}`);
    const quotePreviewDialog = useDialog(`${selectedQuoteId}/preview`, `${selectedQuoteId}`);
    const quoteEmailViewerDialog = useDialog(`${selectedQuoteId}/email`, `${selectedQuoteId}`);
    const showQuote = selectedQuoteId !== null && quoteDialog.show;  // Whether to show the quote page or not

    const handleQuoteSelection = useCallback(
        (quoteId) => {
            navigate(`${quoteId}`);
        },
        []  // eslint-disable-line react-hooks/exhaustive-deps
    );

    return {
        selectedQuoteId,
        formQuote,
        quoteDialog,
        quotePreviewDialog,
        quoteEmailViewerDialog,
        showQuote,
        handleQuoteSelection,
    }
}

export default useQuoteUX;